import React from 'react';
import RouterApp from '../src/components/router';
import { ToastContainer } from 'react-toastify';
function App(props) {
  return (
    <>
      <RouterApp />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme="colored"
      />
    </>
  );
}




export default App;